var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58163 11.3009C8.35871 11.5238 8.35871 11.8667 8.58163 12.0897C8.68449 12.1925 8.83876 12.2612 8.97594 12.2612C9.11312 12.2612 9.2674 12.2097 9.37025 12.0897L12.1992 9.26075C12.4221 9.03783 12.4221 8.69496 12.1992 8.47201L9.37025 5.64298C9.14733 5.42005 8.80446 5.42005 8.58151 5.64298C8.35856 5.8659 8.35859 6.20877 8.58151 6.43172L10.4503 8.30052H1.31189C1.00333 8.30052 0.746094 8.55765 0.746094 8.86632C0.746094 9.17487 1.00322 9.43211 1.31189 9.43211H10.4503L8.58163 11.3009Z",
    fill: "#00436D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4343 0.72229H4.99841C4.68986 0.72229 4.43262 0.97942 4.43262 1.28808V5.64298C4.43262 5.95153 4.68975 6.20877 4.99841 6.20877C5.30696 6.20877 5.5642 5.95165 5.5642 5.64298V1.83673H15.8685V15.8959H5.5642V12.0896C5.5642 11.781 5.30707 11.5238 4.99841 11.5238C4.68986 11.5238 4.43262 11.7809 4.43262 12.0896V16.4445C4.43262 16.7531 4.68975 17.0103 4.99841 17.0103H16.4343C16.7429 17.0103 17.0001 16.7532 17.0001 16.4445V1.28808C17.0001 0.979408 16.7428 0.72229 16.4343 0.72229Z",
    fill: "#00436D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.eac5100858debbd84b288baa7632f563.svg";
export { ForwardRef as ReactComponent };